// PROJECTS
export const ACTIVE_PROJECT = 'ACTIVE_PROJECT';
export const ADD_COMMENT = 'ADD_COMMENT';
export const ADD_VA = 'ADD_VA';
export const COMPOSE_TASK = 'COMPOSE_TASK';
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const CREATE_TASK = 'CREATE_TASK';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const DELETE_TASK = 'DELETE_TASK';
export const FETCH_FIRST_PROJECT = 'FETCH_FIRST_PROJECT';
export const FETCH_PROJECTS = 'FETCH_PROJECTS';
export const FETCH_PROJECTS_ADMIN = 'FETCH_PROJECTS_ADMIN';
export const FETCH_TASKS = 'FETCH_TASKS';
export const FETCH_TASKS_ADMIN = 'FETCH_TASKS_ADMIN';
export const NO_PROJECTS = 'NO_PROJECTS';
export const NO_TASKS = 'NO_TASKS';
export const NOTIFY_ADMIN = 'NOTIFY_ADMIN';
export const SLACK_MESSAGE_SENT = 'SLACK_MESSAGE_SENT';
export const USER_FOUND = 'USER_FOUND';
export const USER_NOT_FOUND = 'USER_NOT_FOUND';

//AUTH
export const SIGNUP_USER = 'SIGNUP_USER';
export const CHECK_CHANGED = 'CHECK_CHANGED';
export const EMAIL_CHANGED = 'EMAIL_CHANGED';
export const LOGIN_USER = 'LOGIN_USER'
export const LOGIN_USER_FAIL = 'LOGIN_USER_FAIL'
export const LOGIN_USER_SUCCESS= 'LOGIN_USER_SUCCESS';
export const LOGOUT_USER_FAIL = 'LOGOUT_USER_SUCCESS'
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS'
export const PASSWORD_CHANGED = 'PASSWORD_CHANGED';
export const USER_AUTHED = 'USER_AUTHED';
export const USER_NOT_AUTHED = 'USER_NOT_AUTHED';

//CALENDAR
export const FETCH_EVENTS = 'FETCH_EVENTS';

//MESSENGER
export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_MESSAGES = 'FETCH_MESSAGES';
export const SELECT_USER = 'SELECT_USER';
export const NEW_MESSAGE = 'NEW_MESSAGE';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const NO_MESSAGES = 'NO_MESSAGES';

//EVENTS
export const EVENT_SELECTED = 'EVENT_SELECTED';
export const NO_EVENTS = 'NO_EVENTS';

//TIMER
export const START_TIMER = 'START_TIMER';
export const PAUSE_TIMER = 'PAUSE_TIMER';
export const RESTART_TIMER = 'RESTART_TIMER';
export const STOP_TIMER = 'STOP_TIMER';
export const INCREMENT_TIMER = 'INCREMENT_TIMER';
export const SET_TIMER_PROJECT = 'SET_TIMER_PROJECT';
export const FETCH_TIMERS = 'FETCH_TIMERS';
export const NO_TIMERS = 'NO_TIMERS';
export const FETCH_TIMERS_REALTOR = 'FETCH_TIMERS_REALTOR';
export const NOTIFY_ADMIN_FINISHED = 'NOTIFY_ADMIN_FINISHED';

//SCHEDULE
export const CREATE_EVENT = 'CREATE_EVENT';
export const CREATE_EVENT_CALENDAR = 'CREATE_EVENT_CALENDAR';
export const DELETE_EVENT = 'DELETE_EVENT';

//NAVBAR
export const TOGGLE_NAV = 'TOGGLE_NAV';
export const TOGGLE_NAV_RESIZE = 'TOGGLE_NAV_RESIZE';
export const INITIAL_NAV = 'INITIAL_NAV';

//DOCUMENT EDITOR
export const GET_ALL_STATIC_DOCUMENTS = 'DOCUMENT_EDITOR/GET_ALL_STATIC';
export const RECEIVED_ALL_STATIC_DOCUMENTS = 'DOCUMENT_EDITOR/GET_ALL_STATIC_SUCCESS';
export const GET_USERS_DOCUMENTS = 'DOCUMENT_EDITOR/GET_USER_DOCUMENTS';
export const RECEIVED_ALL_USER_DOCUMENTS = 'DOCUMENT_EDITOR/GET_ALL_USER_DOCUMENTS_SUCCESS';
export const LOAD_DOCUMENT = 'DOCUMENT_EDITOR/LOAD';
export const LOAD_EXISTING_DOCUMENT = 'DOCUMENT_EDITOR/LOAD_EXISTING';
export const LOAD_DOCUMENT_SUCCESS = 'DOCUMENT_EDITOR/LOAD_SUCCESS';
export const LOAD_DOCUMENT_FAILURE = 'DOCUMENT_EDITOR/LOAD_FAILURE';
export const LOAD_DOCUMENT_IMAGE = 'DOCUMENT_EDITOR/LOAD_DOC_IMAGE';
export const LOAD_DOCUMENT_IMAGE_SUCCESS = 'DOCUMENT_EDITOR/LOAD_DOC_IMAGE_SUCCESS';
export const LOAD_DOCUMENT_IMAGE_FAILURE = 'DOCUMENT_EDITOR/LOAD_DOC_IMAGE_FAILURE';
export const SET_DOCUMENT = 'DOCUMENT_EDITOR/SET_DOCUMENT';
export const SET_NEXT_INPUT_TYPE = 'DOCUMENT_EDITOR/SET_NEXT_INPUT_TYPE';
export const ADD_INPUT = 'DOCUMENT_EDITOR/ADD_INPUT';
export const DELETE_INPUT = 'DOCUMENT_EDITOR/DELETE_INPUT';
export const UPDATE_INPUT_ON_DOCUMENT = 'DOCUMENT_EDITOR/UPDATE_INPUT';
export const MOVE_INPUT_ON_DOCUMENT = 'DOCUMENT_EDITOR/MOVE_INPUT';
export const SAVE_CURRENT_DOCUMENT = 'DOCUMENT_EDITOR/SAVE_CURRENT_DOCUMENT';
export const SAVE_CURRENT_DOCUMENT_SUCCESS = 'DOCUMENT_EDITOR/SAVE_CURRENT_DOCUMENT_SUCCESS';
export const FINALIZE_DOCUMENT = 'DOCUMENT_EDITOR/FINALIZE';
export const FINALIZE_DOCUMENT_SUCCESS = 'DOCUMENT_EDITOR/FINALIZE_SUCCESS';

// COMMON
export const CREATE_PDF_FROM_HTML = 'COMMON/CREATE_PDF_FROM_HTML';
export const CREATE_PDF_FROM_HTML_SUCCESS = 'COMMON/CREATE_PDF_FROM_HTML_SUCCESS';
export const CREATE_PDF_FROM_HTML_ERROR = 'COMMON/CREATE_PDF_FROM_HTML_ERROR';



// WEBPACK FOOTER //
// ./src/_actions/types.js